import { Component, Input } from '@angular/core'

@Component({
  selector: 'hs-app-footer-item',
  templateUrl: './app-footer-item.component.html',
  styleUrls: ['./app-footer-item.component.scss'],
})
export class AppFooterItemComponent {
  @Input() position: 'left' | 'right' = 'left'
}
